import { Component, computed, effect, inject, signal } from '@angular/core';
import { IWizardStepComponent } from '@mwe/models';
import { UiComponentsModule } from '@mwe/ui/components';
import { BeraterService } from '../../../service/berater/berater.service';
import { CustomerRegistrationService } from '../../../service/customer-registration/customer-registration.service';
import Keycloak from 'keycloak-js';
import { BeraterDropdownOptionPipe } from '../../../pipes/berater-dropdown-option.pipe';
import { toSignal } from '@angular/core/rxjs-interop';
import { TopPageComponent } from '@shared-ikp/layout/top-page/top-page.component';
import { DropdownComponent } from '@shared-ikp/components/dropdown/dropdown.component';
import { IBerater } from '../../../model/berater-http.model';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'ikp-berater-agent-selection',
  templateUrl: './agent_selection.component.html',
  standalone: true,
  imports: [UiComponentsModule, TopPageComponent, DropdownComponent, BeraterDropdownOptionPipe, FormsModule],
})
export class AgentSelectionComponent implements IWizardStepComponent {
  private readonly beraterService = inject(BeraterService);
  private readonly keycloak = inject(Keycloak);
  protected readonly registrationService = inject(CustomerRegistrationService);

  selectedCompanies = computed(() => this.registrationService.registrationModel().companies.map(u => u.gpNr));
  berater = toSignal(this.beraterService.loadBerater({ geschaeftspartnerNummern: this.selectedCompanies() }));
  selectedBerater = signal<IBerater>(null);

  constructor() {
    effect(() => {
      const beraterList = this.berater();
      if (!beraterList?.length) {
        return;
      }

      const savedEmail = this.registrationService.registrationModel().berater?.email;
      const loggedInEmail = this.keycloak.tokenParsed?.email;
      const emailToFind = savedEmail ?? loggedInEmail;

      const preselected = beraterList.find(b => b.email === emailToFind) ?? beraterList[0];
      this.selectedBerater.set(preselected);
    });

    effect(() => {
      this.registrationService.isNextButtonDisabled.set(!this.selectedBerater());
    });
  }

  validate(): boolean {
    return !!this.selectedBerater()?.id;
  }

  hasAllNeededData(): boolean {
    return this.selectedCompanies().length > 0;
  }

  submit(): Promise<void> {
    this.registrationService.setSelectedBerater(this.selectedBerater());
    return Promise.resolve(undefined);
  }
}
